import { useCases } from '../../../mocks/featuresData';

export default function UseCasesSection() {
  return (
    <section id="use-cases" className="py-32 bg-dark-lighter relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-1/4 left-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>

      <div className="max-w-[1400px] mx-auto px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-white mb-6">
            Branchen & Anwendungsbereiche
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Unsere maßgeschneiderten Lösungen passen sich perfekt an die spezifischen Anforderungen Ihrer Branche an.
          </p>
        </div>

        {/* Use Cases Grid */}
        <div className="grid grid-cols-4 gap-8">
          {useCases.map((useCase) => (
            <div
              key={useCase.id}
              className="bg-dark rounded-3xl p-10 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:shadow-primary/30 cursor-pointer group"
            >
              {/* Icon */}
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-primary to-primary-light flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${useCase.icon} text-4xl text-white`}></i>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-white mb-4">
                {useCase.title}
              </h3>

              {/* Description */}
              <p className="text-gray-400 leading-relaxed mb-6">
                {useCase.description}
              </p>

              {/* Features List */}
              <ul className="space-y-3">
                {useCase.features.map((feature, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-primary text-lg mt-0.5 flex-shrink-0"></i>
                    <span className="text-sm text-gray-400">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
